import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import SlackIconSvg from './icon-slack.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SlackIconSvg {...validProps} />;
}
SvgComponent.iconName = 'slackIcon';

export const SlackIcon = svgIconWrapper(SvgComponent);
